import type { JSX } from "react";

export default function IncludeExcludeSelection<
  OptionType extends Record<string, string> & {
    id: string;
  },
>({
  labelKey,
  countKey,
  renderIcon,
  options,
  onSelect,
}: {
  labelKey: keyof OptionType;
  countKey: keyof OptionType;
  renderIcon: (option: OptionType) => JSX.Element;
  options: OptionType[];
  onSelect: (
    updateType: "include" | "exclude",
    selectedOption: OptionType,
  ) => void;
}) {
  return (
    <div className="flex max-h-[216px] flex-col overflow-y-scroll scrollbar-thin">
      {options.map((option) => {
        const iconComponent = renderIcon(option);
        const count = option[countKey];

        return (
          <div
            className="flex shrink-0 items-center gap-x-2 rounded-xl p-2 hover:bg-black-100"
            key={option.id}
          >
            {iconComponent}
            <div className="flex flex-col gap-y-0.5 overflow-hidden">
              <span className="line-clamp-1 text-sm-medium">
                {option[labelKey]}
              </span>
              {count && <span className="text-xs text-black-500">{count}</span>}
            </div>
            <div className="text-button-12 ml-auto flex items-center gap-x-1.5">
              <button
                type="button"
                className="text-button-xs hover:text-black-700 hover:underline"
                onClick={() => onSelect("include", option)}
              >
                Include
              </button>
              <div className="h-3 w-px bg-black-200" />
              <button
                type="button"
                className="text-button-xs hover:text-red-500 hover:underline"
                onClick={() => onSelect("exclude", option)}
              >
                Exclude
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
